<template>
  <div>
    <v-timeline-item color="bluePcm" small>
      <v-card color="background">
        <v-row dense>
          <v-col cols="12">
            <v-card-title>
              Evento: Transferência para Conferência
            </v-card-title>
          </v-col>
        </v-row>
        <v-row align="center" align-content="center" dense>
          <v-col>
            <v-card-text>
              <strong>Data início: </strong>
              {{ timeToDate(evento.dateStartCall) }}
            </v-card-text>
          </v-col>
          <v-col>
            <v-card-text>
              <strong>Centro de Custo: </strong>
              {{
                evento.centroDeCusto
                  ? `${evento.centroDeCusto.codigo} - ${evento.centroDeCusto.description}`
                  : 'Sem Centro de Custo'
              }}
            </v-card-text>
          </v-col>
        </v-row>
        <v-row dense align="center">
          <v-col>
            <v-card-text>
              <strong>Conferência: </strong>
              {{ this.getDescriptionSpecificConferencia(evento.atdCall) }}
            </v-card-text>
          </v-col>
          <v-col>
            <v-card-text>
              <strong>Participante: </strong>
              {{ evento.transferido }}
            </v-card-text>
          </v-col>

          <v-col>
            <v-card-text>
              <strong>Transferido por: </strong>
              {{ evento.numeroOrigem }}
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
    </v-timeline-item>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'

import relatorioChamadasStore from '../_store'
import { listaRelatorioChamadasMethods } from '../_utils/listaRelatorioChamadasMethods'

export default {
  name: 'TimeLineTransferencia',
  props: {
    evento: Object,
  },
  computed: {
    ...mapGetters('listaRelatorioChamadasModulePABXStore', ['getDescriptionSpecificConferencia']),
  },
  async created() {
    registerVuexModule(this.$store, 'listaRelatorioChamadasModulePABXStore', relatorioChamadasStore)
  },
  methods: {
    ...listaRelatorioChamadasMethods,
  },
}
</script>
